
import React from 'react'
import './topicsdisplay.css'
import { Delete, Check, Cancel} from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import {ScrollTextPrompt} from "../scrolltext/ScrollTextPrompt"
import { ButtonAIProvider } from '../buttonaiprovider/ButtonAIProvider'


export const TopicsDisplayHeader = ({ displayprompt, displayicons, changeConfirmDelete, onDeletePrompt, onCopy, showprompts }) => {
  let {
    isLoading,
} = React.useContext(StatusContext); 

  
  return (
    <div disabled={isLoading} >
     
      {
       
        <div key={displayprompt.id}>
          {
            showprompts &&  
            <div className="scrollTextQuestion" >
              <div className='flex-container'>
              {
                (displayicons) ? (
              
                  <>
                   <Check className="promptIconColored"  onClick={() => { !isLoading && onDeletePrompt(displayprompt)}} />
                   <Cancel className="promptIconColored"  onClick={() => { !isLoading && changeConfirmDelete(displayprompt, false) }} />
                  </>
                )
                  : 
                (
                  <>
                
                  <Delete className="promptIconColored"  onClick={() => { !isLoading && changeConfirmDelete(displayprompt, true) }} />
                  </>
                )}

                  {
                    displayprompt.aiprovider &&
                    <ButtonAIProvider provider={displayprompt.aiprovider} model={displayprompt.ainame}/>
                  }
                </div>

             {<ScrollTextPrompt text={displayprompt.prompt}/>}
          
            </div>
            
          }
        </div>
        
      }

     
    </div>
  )
}


TopicsDisplayHeader.defaultProps = {
  showprompts: true,
  showRefresh: true
};

export default TopicsDisplayHeader
